{
  "defaultLocale": "en",
  "locales": ["en"],
  "files": {
    "gt": {
      "output": "public/i18n/[locale].json"
    }
  }
}
